import script from "./EditDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditDetailModal.vue?vue&type=style&index=0&id=0f6646f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6646f3"]])

export default __exports__